import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActiveAudioCallUiService {
  private readonly minimizedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public readonly minimized$: Observable<boolean> = this.minimizedSubject.asObservable();

  public get isMinimized(): boolean {
    return this.minimizedSubject.value;
  }

  public minimize(): void {
    if (this.minimizedSubject.value) return;
    this.minimizedSubject.next(true);
  }

  public expand(): void {
    if (!this.minimizedSubject.value) return;
    this.minimizedSubject.next(false);
  }

  public clear(): void {
    this.expand();
  }
}
